/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint no-underscore-dangle: 0 */
import {
  ClickAwayListener,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Avatar,
  Theme,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  List,
  Grid,
  Modal,
  Box,
  Tooltip,
} from '@mui/material';
import QRCode from 'react-qr-code';
import { MetaMaskButton } from '../../../app/new/container/components/metamask-button.component';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import React, {
  ReactNode,
  PropsWithChildren,
  useEffect,
  useRef,
  useState,
  useLayoutEffect,
} from 'react';
import { useDispatch } from 'react-redux';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { grey } from '@mui/material/colors';
import SlidingPanel from 'react-sliding-side-panel';
import {
  QCNewLogo,
  SubscriberIcon,
  ReferralsNewIcon,
  ReferrersIcon,
} from '../../../assets/svg';
import 'react-sliding-side-panel/lib/index.css';
import { logout } from '../../../store/common/common.reducer';
import styles from './layout.module.scss';
import { AuthService } from '../../services/auth/auth.service';
import ENVIRONMENTS from '../../../environments';
import Notifications from '../notifications/notifications.component';
import { getProfileImageUrl } from '../../helpers/helpers';
import { useUserData } from '../../contexts/user-data.context';
import { UserPlaceholder, QuickieMemeIcons } from '../../../assets/images';
import Foundingicon from '../../../assets/images/Foundingmembers.png';
import Betaicon from '../../../assets/images/betaTester.png';
import Earlyicon from '../../../assets/images/Earlyadopters.png';
import QRCenterLogo from '../../../assets/images/QRCenterLogo.png';
import Defaultprofile from '../../../assets/images/DefaultProfile.png';
import Discordicon from '../../../assets/images/discord.png';
import { store } from '../../../store/create-store';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    profileImage: {
      width: 'clamp(40px, 10vw, 50px)', // Responsive image size
      height: 'clamp(40px, 10vw, 50px)',
      borderRadius: '50%',
      [theme.breakpoints.down('xs')]: {
        width: '35px', // Smaller for 320px
        height: '35px',
      },
    },
    qrprofileImage: {
      width: 'clamp(80px, 20vw, 100px)', // Responsive image size
      height: 'clamp(80px, 20vw, 100px)',
      borderRadius: '50%',
      [theme.breakpoints.down('xs')]: {
        width: '65px', // Smaller for 320px
        height: '65px',
      },
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalContent: {
      backgroundColor: '#fff',
      borderRadius: '20px', // Slightly larger radius for a modern look
      padding: '32px', // More padding for breathing room
      textAlign: 'center',
      outline: 'none',
      maxWidth: '90%',
      width: '420px', // Slightly wider modal
      position: 'relative',
      boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)', // Stronger shadow for depth
      border: 'none', // Remove border for a cleaner look
    },
    closeButton: {
      position: 'absolute',
      top: '16px',
      right: '16px',
      cursor: 'pointer',
      color: '#999', // Lighter color for a softer look
      fontSize: '28px', // Larger icon
      transition: 'color 0.2s ease', // Smooth hover transition
      '&:hover': {
        color: '#333', // Darker on hover
      },
    },
    modalTitle: {
      fontSize: 'clamp(18px, 5vw, 20px)', // Responsive font size, smaller on 320px
      fontWeight: 700,
      margin: '0',
      marginLeft: '8px', // Slightly reduced for small screens
      color: '#1a1a1a',
      textTransform: 'uppercase',
      fontFamily: 'Roboto, sans-serif',
      [theme.breakpoints.down('xs')]: {
        // Targeting 320px and below
        fontSize: '16px', // Smaller font for very small screens
        marginLeft: '5px',
      },
    },
    modalSubtitle: {
      fontSize: '24px', // Smaller for better hierarchy
      color: '#1a1a1a', // Softer color
      margin: '12px 0 20px 0', // Adjusted spacing
      paddingTop: '30px',
      fontWeight: 700,
      textTransform: 'uppercase',
      fontFamily: 'Roboto, sans-serif',
    },
    modalBadge: {
      marginBottom: '20px',
      width: '70px', // Slightly larger badge
      borderRadius: '50%', // Ensure circular shape
      border: '2px solid #f5f5f5', // Subtle border around badge
      transition: 'transform 0.3s ease', // Add subtle animation
      '&:hover': {
        transform: 'scale(1.05)', // Slight zoom on hover
      },
    },
    referralLinkContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: '20px',
      gap: '8px', // Space between link and copy button
    },
    referralLink: {
      fontSize: '16px',
      color: '#6638b6',
      wordBreak: 'break-all',
      fontWeight: 400,
    },
    copyButton: {
      backgroundColor: '#f0f0f0',
      border: 'none',
      borderRadius: '8px',
      padding: '6px 12px',
      cursor: 'pointer',
      fontSize: '12px',
      color: '#333',
      fontWeight: 500,
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: '#e0e0e0',
      },
    },
    modalHeaderIcon: {
      marginLeft: 'clamp(20px, 5vw, 40px)', // Responsive margin
      color: '#888',
      [theme.breakpoints.down('xs')]: {
        marginLeft: '10px', // Reduced for small screens
        fontSize: '20px', // Smaller icon
      },
    },
    profileBadgeContainer: {
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      left: '50%', // Simplified to center horizontally
      top: '35%',
      [theme.breakpoints.down('xs')]: {
        top: '30%', // Adjusted for smaller screens
        left: '50%',
      },
    },
    qrCodeContainer: {
      border: '2px solid #B7B7B7',
      padding: '50px',
      paddingTop: '80px',
      paddingBottom: '40px',
      paddingLeft: '20px',
      paddingRight: '20px',
      boxSizing: 'border-box',
      marginTop: '80px',
      borderRadius: '20px',
      [theme.breakpoints.down('sm')]: {
        padding: '20px',
        paddingTop: '60px',
        paddingBottom: '20px',
        marginTop: '40px',
        borderRadius: '15px',
      },
    },
  }),
);

function Layout(
  props: PropsWithChildren<RouteComponentProps<ReactNode>>,
): JSX.Element {
  const classes = useStyles();

  const dispatch = useDispatch();

  const { user } = useUserData();
  const { children, history } = props;
  const [open, setOpen] = useState(false);
  const [openPanel, setOpenPanel] = useState(false);
  const [openQRModal, setOpenQRModal] = useState(false);
  const anchorRef = useRef<any>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [openDashboard, setOpenDashboard] = React.useState(false);
  const [openHelp, setOpenHelp] = React.useState(false);
  const [openCalculator, setOpenCalculator] = React.useState(false);
  const [windowSize, setWindowSize] = React.useState(0);
  const [openAdmin, setOpenAdmin] = React.useState(false);
  const { common } = store.getState();
  const { auth = {} } = common;
  const { token } = auth;
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(referralLink)
      .then(() => {
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 1500); // Hide tooltip after 1.5 seconds
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  console.log('user', user);
  const getVipInfo = (
    vipTier: string | undefined,
  ): { icon: string | null; badgeName: string | null } => {
    switch (vipTier) {
      case 'FOUNDING_MEMBER':
        return { icon: Foundingicon, badgeName: 'Founding Member' };
      case 'BETA_TESTER':
        return { icon: Betaicon, badgeName: 'Beta Tester' };
      case 'EARLY_ADOPTER':
        return { icon: Earlyicon, badgeName: 'Early Adopter' };
      case 'STANDARD':
      default:
        return { icon: null, badgeName: null }; // Hide for STANDARD or undefined
    }
  };

  const { icon: vipIconSrc, badgeName } = getVipInfo(user?.vipTier);

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
  };

  const handleClick = () => {
    setOpenDashboard(!openDashboard);
  };

  const handleClickCalculator = () => {
    setOpenCalculator(!openCalculator);
  };

  const handleClickHelp = () => {
    setOpenHelp(!openHelp);
  };

  const handleToggle = () => {
    setOpen((prevOpen: boolean) => !prevOpen);
  };

  const logoutHandle = async () => {
    const redirectUri = localStorage.getItem('redirect_uri');
    try {
      handleToggle();
      await new AuthService().logout();
      dispatch(logout());
    } finally {
      dispatch(logout());
      localStorage.removeItem('refferingChannel');
      if (redirectUri?.endsWith('://app')) {
        window.location.href = redirectUri;
      } else {
        history.push('/');
      }
    }
  };

  const handleClose = (event: any) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setOpen(false);
  };

  const handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  };

  function closePanel() {
    setOpenPanel(false);
  }

  const handleClickAdmin = () => {
    if (!openAdmin) {
      setOpenDashboard(false);
      setOpenHelp(false);
      setOpenCalculator(false);
    }
    setOpenAdmin(!openAdmin);
  };

  const prevOpen = React.useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current?.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const performLogout = async (event: any) => {
    handleClose(event);
    try {
      await new AuthService().logout();
      window.location.href = ENVIRONMENTS.KEYCLOAK_REDIRECT_URI;
    } finally {
      dispatch(logout());
    }
  };

  useLayoutEffect(() => {
    function updateSize() {
      setWindowSize(window.innerWidth);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const handleOpenQRModal = () => {
    setOpenQRModal(true);
  };

  const handleCloseQRModal = () => {
    setOpenQRModal(false);
  };

  const referralLink = user?.referralPage || 'https://dev.quickcam.app/default';
  const QuickieMemeLink = `https://dev.quickie.meme/?token=${token}`;

  return (
    <Grid className={styles.layout} container direction="column">
      <Grid item className={styles.header} direction="row">
        {user && (
          <IconButton
            className={styles.iconContainer}
            onClick={() => setOpenPanel(true)}
            size="large"
          >
            <span className="material-icons-outlined">menu</span>
          </IconButton>
        )}
        <Link to="/">
          {/* <div className={styles.metamaskButton}>
            <MetaMaskButton />
          </div> */}
          <p className={styles.heading}>
            <img src={QCNewLogo} alt="QuickCamLogoHeader" width="36" />
            QuickCam
          </p>
        </Link>
        <button
          type="button"
          className={styles.qrButton}
          onClick={handleOpenQRModal}
        >
          <span className="material-icons-outlined">share </span>
          Share
        </button>
        <a
          href="https://discord.com/channels/1223703915191603421/1224490894225445094/1375329450513928306"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.discordButton}
          aria-label="Join our Discord server"
        >
          <img
            src={Discordicon}
            alt="Discord Icon"
            className={styles.discordIcon}
          />
          Join Discord Server
        </a>

        <div className={styles.actions}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
              className={`${styles.vipIcon} ${!vipIconSrc || !badgeName ? styles.hidden : ''
                }`}
            >
              {badgeName && (
                <span className={styles.vipBadgeName}>{badgeName}</span>
              )}
              {vipIconSrc && <img src={vipIconSrc} alt="VIP Icon" />}
            </div>
            <div className={styles.quickieButtonContainer}>
              <button
                className={styles.quickieButton}
                type="button"
                onClick={() => {
                  navigator.clipboard.writeText(QuickieMemeLink);
                  window.open(QuickieMemeLink, '_blank');
                }}
              >
                <img
                  src={QuickieMemeIcons}
                  alt="Quickie Icon"
                  style={{ width: '21px', height: '21px' }}
                />
                Buy Quickies
              </button>
            </div>

            <div className={styles.metamaskButton}>
              <MetaMaskButton />
            </div>
            <div style={{ marginRight: 20 }}>
              <Notifications />
            </div>
            <Avatar
              className={`${classes.profileImage} ${styles.profileImage}`}
              src={
                getProfileImageUrl(user?.profileImageURL || '') ||
                `${UserPlaceholder}`
              }
              onClick={handleToggle}
              ref={anchorRef}
            >
              {(
                `${user?.firstName?.charAt(0)}${user?.lastName?.charAt(0)}` ||
                user?.channelName?.charAt(0) ||
                ''
              ).toUpperCase()}
            </Avatar>
          </div>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="account-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem style={{ textTransform: 'none' }}>
                        @{user?.channelName}
                      </MenuItem>
                      <hr />
                      <MenuItem
                        onClick={() => {
                          history.push('/u/settings');
                          setOpen(false);
                        }}
                      >
                        Edit Profile
                      </MenuItem>
                      <hr />
                      <MenuItem onClick={logoutHandle}>Logout</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </Grid>

      <Modal
        open={openQRModal}
        onClose={handleCloseQRModal}
        className={classes.modal}
      >
        <Box className={classes.modalContent}>
          <Box className={classes.modalHeader}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span
                className={`material-icons-outlined ${classes.modalHeaderIcon}`}
              >
                qr_code
              </span>
              <h2 className={classes.modalTitle}>QR CODE PREVIEW</h2>
            </Box>
            <span className={classes.closeButton} onClick={handleCloseQRModal}>
              <span className="material-icons-outlined">close</span>
            </span>
          </Box>
          <p className={classes.modalSubtitle} style={{ marginTop: '20px' }}>
            SHARE YOUR QR CODE
          </p>
          <div className={classes.qrCodeContainer}>
            <div className={classes.profileBadgeContainer}>
              <img
                className={classes.qrprofileImage}
                src={
                  getProfileImageUrl(user?.profileImageURL || '') ||
                  Defaultprofile
                }
                alt="User Profile Badge"
              />
            </div>
            <QRCode
              value={referralLink}
              size={200}
              bgColor="#ffffff"
              fgColor="#6638b6"
              level="H"
              includeMargin={false}
            />
            <img
              src={QRCenterLogo}
              alt="QR Center Logo"
              style={{
                position: 'absolute',
                top: '65%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 'clamp(30px, 8vw, 35px)', // Responsive logo size
                height: 'clamp(30px, 8vw, 35px)',
              }}
            />
          </div>
          <div className={classes.referralLinkContainer}>
            <p className={classes.referralLink}>{referralLink}</p>
            <Tooltip
              title="Your referral link was copied."
              open={copied}
              placement="top"
              disableFocusListener
              disableHoverListener
              disableTouchListener
              componentsProps={{
                tooltip: {
                  style: {
                    fontSize: '1rem',
                    backgroundColor: '#333',
                    padding: '8px 12px',
                  }, // Adjust as needed
                },
              }}
            >
              <button
                type="button"
                className={classes.copyButton}
                onClick={handleCopy}
                aria-label="Copy referral link"
              >
                Copy
              </button>
            </Tooltip>
          </div>
        </Box>
      </Modal>

      <Grid
        item
        direction="column"
      // className={styles.content}
      >
        {children}
      </Grid>
      <SlidingPanel
        type="left"
        isOpen={openPanel}
        size={75}
        backdropClicked={() => closePanel()}
      >
        <div className={styles.sidePanelContainer}>
          <div className={styles.sidePanelHeader}>
            <Link
              to="/u/dashboard"
              className={styles.sidePanelHeading}
              onClick={() => {
                closePanel();
              }}
            >
              <img src={QCNewLogo} alt="QuickCamLogoHeader" width="50" />
              QuickCam
            </Link>
          </div>
          <div className={styles.sidePanelLinks}>
            <ListItem
              button
              className={styles.listItem}
              selected={selectedIndex === 0}
              onClick={(event: any) => {
                handleClick();
                handleListItemClick(event, 0);
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  dashboard
                </span>
              </ListItemIcon>
              <ListItemText
                primary="Dashboard"
                onClick={(event: any) => {
                  handleListItemClick(event, 0);
                  setSelectedIndex(0);
                  closePanel();
                  history.push('https://quickcam.social/u/dashboard');
                }}
              />
              {!openDashboard ? (
                <span className="material-icons">expand_more</span>
              ) : (
                <span className="material-icons">expand_less</span>
              )}
            </ListItem>
            <Collapse in={openDashboard} timeout="auto" unmountOnExit>
              <List component="div" disablePadding className={styles.subMenu}>
                <ListItem
                  className={styles.listItem}
                  button
                  selected={selectedIndex === 41}
                  component={Link}
                  to="/u/connections/referrals"
                  onClick={(event: any) => {
                    closePanel();
                    handleListItemClick(event, 41);
                  }}
                >
                  <ListItemIcon>
                    <span
                      style={{ width: '30px' }}
                      className={`material-icons ${styles.iconMaterialDesign}`}
                    >
                      <img src={ReferralsNewIcon} alt="referralsNewIcon" />
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="Referrals" />
                </ListItem>
                <ListItem
                  className={styles.listItem}
                  button
                  selected={selectedIndex === 42}
                  component={Link}
                  to="/u/connections/referrers"
                  onClick={(event: any) => {
                    closePanel();
                    handleListItemClick(event, 42);
                  }}
                >
                  <ListItemIcon>
                    <span
                      style={{ width: '30px' }}
                      className={`material-icons ${styles.iconMaterialDesign}`}
                    >
                      <img src={ReferrersIcon} alt="referrersIcon" />
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="Referring Channels" />
                </ListItem>
                <ListItem
                  className={styles.listItem}
                  button
                  selected={selectedIndex === 43}
                  component={Link}
                  to="/u/connections/subscribers"
                  onClick={(event: any) => {
                    closePanel();
                    handleListItemClick(event, 43);
                  }}
                >
                  <ListItemIcon>
                    <span
                      style={{ width: '30px' }}
                      className={`material-icons ${styles.iconMaterialDesign}`}
                    >
                      <img src={SubscriberIcon} alt="subscriberIcon" />
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="Subscribers" />
                </ListItem>
                <ListItem
                  className={styles.listItem}
                  button
                  selected={selectedIndex === 44}
                  component={Link}
                  to="/u/connections/favorites"
                  onClick={(event: any) => {
                    closePanel();
                    handleListItemClick(event, 44);
                  }}
                >
                  <ListItemIcon>
                    <span
                      style={{ width: '30px' }}
                      className={`material-icons ${styles.iconMaterialDesign}`}
                    >
                      favorite_border
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="Favorites" />
                </ListItem>
                <ListItem
                  className={styles.listItem}
                  button
                  selected={selectedIndex === 44}
                  component={Link}
                  to="/u/connections/following"
                  onClick={(event: any) => {
                    closePanel();
                    handleListItemClick(event, 44);
                  }}
                >
                  <ListItemIcon>
                    <span
                      style={{ width: '30px' }}
                      className={`material-icons ${styles.iconMaterialDesign}`}
                    >
                      person_add
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="Following" />
                </ListItem>
                <ListItem
                  className={styles.listItem}
                  button
                  selected={selectedIndex === 45}
                  component={Link}
                  to="/u/connections/followers"
                  onClick={(event: any) => {
                    closePanel();
                    handleListItemClick(event, 45);
                  }}
                >
                  <ListItemIcon>
                    <span
                      style={{ width: '30px' }}
                      className={`material-icons ${styles.iconMaterialDesign}`}
                    >
                      group
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="Followers" />
                </ListItem>
              </List>
            </Collapse>

            {user?.roles?.includes('admin') && (
              <>
                <ListItem
                  button
                  className={styles.listItem}
                  selected={selectedIndex === 2}
                  onClick={(event: any) => {
                    handleClickAdmin();
                    handleListItemClick(event, 2);
                  }}
                >
                  <ListItemIcon>
                    <span
                      className={`material-icons ${styles.iconMaterialDesign}`}
                    >
                      dashboard
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="Admin" />
                  {!openAdmin ? (
                    <span className="material-icons">expand_more</span>
                  ) : (
                    <span className="material-icons">expand_less</span>
                  )}
                </ListItem>
                <Collapse in={openAdmin} timeout="auto" unmountOnExit>
                  <List
                    component="div"
                    disablePadding
                    className={styles.subMenu}
                  >
                    <ListItem
                      className={styles.listItem}
                      button
                      selected={selectedIndex === 21}
                      component={Link}
                      to="/u/admin/dashboard"
                      onClick={(event: any) => {
                        closePanel();
                        handleListItemClick(event, 21);
                      }}
                    >
                      <ListItemIcon>
                        <span
                          style={{ width: '30px' }}
                          className={`material-icons ${styles.iconMaterialDesign}`}
                        >
                          speed
                        </span>
                      </ListItemIcon>
                      <ListItemText primary="QuickCam Dashboard" />
                    </ListItem>
                    <ListItem
                      className={styles.listItem}
                      button
                      selected={selectedIndex === 22}
                      component={Link}
                      to="/u/admin/quickie"
                      onClick={(event: any) => {
                        closePanel();
                        handleListItemClick(event, 22);
                      }}
                    >
                      <ListItemIcon>
                        <span
                          style={{ width: '30px' }}
                          className={`material-icons ${styles.iconMaterialDesign}`}
                        >
                          speed
                        </span>
                      </ListItemIcon>
                      <ListItemText primary="Quickie Dashboard" />
                    </ListItem>
                  </List>
                </Collapse>
              </>
            )}

            {/* MemeCoins */}
            <ListItem
              className={styles.listItem}
              button
              selected={selectedIndex === 11}
              component={Link}
              to="/u/meme-coins"
              onClick={(event: any) => {
                closePanel();
                handleListItemClick(event, 11);
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  payment
                </span>
              </ListItemIcon>
              <ListItemText primary="Meme Coins" />
            </ListItem>

            {/* Announcements */}
            {windowSize < 768 && (
              <ListItem
                className={styles.listItem}
                button
                selected={selectedIndex === 4}
                component={Link}
                type="smallHide"
                to="/u/announcements"
                onClick={(event: any) => {
                  closePanel();
                  handleListItemClick(event, 4);
                }}
                style={{ minWidth: '40px !important' }}
              >
                <ListItemIcon style={{ minWidth: '40px !important' }}>
                  <span
                    className={`material-icons ${styles.iconMaterialDesign}`}
                  >
                    campaign
                  </span>
                </ListItemIcon>
                <ListItemText primary="Announcements" />
              </ListItem>
            )}
            {/* Downloads */}
            <ListItem
              className={styles.listItem}
              button
              selected={selectedIndex === 6}
              component={Link}
              to="/u/downloads"
              onClick={(event: any) => {
                closePanel();
                handleListItemClick(event, 6);
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  file_download
                </span>
              </ListItemIcon>
              <ListItemText primary="Downloads" />
            </ListItem>
            {/* Help */}
            <ListItem
              button
              className={styles.listItem}
              selected={selectedIndex === 14}
              onClick={event => {
                handleClickHelp();
                handleListItemClick(event, 14);
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  help
                </span>
              </ListItemIcon>
              <ListItemText primary="Help" />
              {!openHelp ? (
                <span className="material-icons">expand_more</span>
              ) : (
                <span className="material-icons">expand_less</span>
              )}
            </ListItem>
            <Collapse in={openHelp} timeout="auto" unmountOnExit>
              <List component="div" disablePadding className={styles.subMenu}>
                <ListItem
                  className={styles.listItem}
                  button
                  selected={selectedIndex === 33}
                  component={Link}
                  to="/u/help/faqs"
                  onClick={(event: any) => {
                    closePanel();
                    handleListItemClick(event, 33);
                  }}
                >
                  <ListItemIcon>
                    <span
                      style={{ width: '30px' }}
                      className={`material-icons ${styles.iconMaterialDesign}`}
                    >
                      quiz
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="FAQs" />
                </ListItem>
                <ListItem
                  className={styles.listItem}
                  button
                  selected={selectedIndex === 34}
                  component={Link}
                  to="/u/help/tutorials"
                  onClick={(event: any) => {
                    closePanel();
                    handleListItemClick(event, 34);
                  }}
                >
                  <ListItemIcon>
                    <span
                      style={{ width: '30px' }}
                      className={`material-icons ${styles.iconMaterialDesign}`}
                    >
                      home_repair_service
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="Tutorials" />
                </ListItem>
              </List>
            </Collapse>

            {/* LeaderBoard */}
            <ListItem
              className={styles.listItem}
              button
              selected={selectedIndex === 12}
              component={Link}
              to="/u/leaderboard"
              onClick={(event: any) => {
                closePanel();
                handleListItemClick(event, 12);
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  leaderboard
                </span>
              </ListItemIcon>
              <ListItemText primary="LeaderBoard" />
            </ListItem>
            {/* Commissions */}
            <ListItem
              className={styles.listItem}
              button
              selected={selectedIndex === 13}
              component={Link}
              to="/u/commissions"
              onClick={(event: any) => {
                closePanel();
                handleListItemClick(event, 13);
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  payment
                </span>
              </ListItemIcon>
              <ListItemText primary="Commissions" />
            </ListItem>
            {/* <Collapse in={openDashboard} timeout="auto" unmountOnExit>
              <List component="div" disablePadding className={styles.subMenu}>
                <ListItem
                  className={styles.listItem}
                  button
                  selected={selectedIndex === 41}
                  component={Link}
                  to="/u/connections/referrals"
                  onClick={(event: any) => {
                    closePanel();
                    handleListItemClick(event, 41);
                  }}
                >
                  <span
                    style={{ width: '30px' }}
                    className={`material-icons ${styles.iconMaterialDesign}`}
                  >
                    <img src={ReferralsNewIcon} alt="referralsNewIcon" />
                  </span>
                  <ListItemText primary="Referrals" />
                </ListItem>
                <ListItem
                  className={styles.listItem}
                  button
                  selected={selectedIndex === 42}
                  component={Link}
                  to="/u/connections/referrers"
                  onClick={(event: any) => {
                    closePanel();
                    handleListItemClick(event, 42);
                  }}
                >
                  <span
                    style={{ width: '30px' }}
                    className={`material-icons ${styles.iconMaterialDesign}`}
                  >
                    <img src={ReferrersIcon} alt="referrersIcon" />
                  </span>
                  <ListItemText primary="Referring Channels" />
                </ListItem>
                <ListItem
                  className={styles.listItem}
                  button
                  selected={selectedIndex === 43}
                  component={Link}
                  to="/u/connections/subscribers"
                  onClick={(event: any) => {
                    closePanel();
                    handleListItemClick(event, 43);
                  }}
                >
                  <span
                    style={{ width: '30px' }}
                    className={`material-icons ${styles.iconMaterialDesign}`}
                  >
                    <img src={SubscriberIcon} alt="subscriberIcon" />
                  </span>
                  <ListItemText primary="subscribers" />
                </ListItem>
                <ListItem
                  className={styles.listItem}
                  button
                  selected={selectedIndex === 44}
                  component={Link}
                  to="/u/connections/favorites"
                  onClick={(event: any) => {
                    closePanel();
                    handleListItemClick(event, 44);
                  }}
                >
                  <span
                    style={{ width: '30px' }}
                    className={`material-icons ${styles.iconMaterialDesign}`}
                  >
                    favorite_border
                  </span>
                  <ListItemText primary="Favorites" />
                </ListItem>
              </List>
            </Collapse> */}

            {/* Share */}
            {/* <ListItem
              className={styles.listItem}
              button
              selected={selectedIndex === 3}
              component={Link}
              to="/u/share"
              onClick={(event: any) => {
                closePanel();
                handleListItemClick(event, 3);
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  share
                </span>
              </ListItemIcon>
              <ListItemText primary="Share" />
            </ListItem> */}

            {/* Admin Dashboard */}
            {/* {windowSize < 768 && (
              <ListItem
                className={styles.listItem}
                button
                selected={selectedIndex === 4}
                component={Link}
                type="smallHide"
                to="/u/announcements"
                onClick={(event: any) => {
                  closePanel();
                  handleListItemClick(event, 4);
                }}
                style={{ minWidth: '40px !important' }}
              >
                <ListItemIcon style={{ minWidth: '40px !important' }}>
                  <span
                    className={`material-icons ${styles.iconMaterialDesign}`}
                  >
                    dashboard
                  </span>
                </ListItemIcon>
                <ListItemText primary="Admin Dashboard" />
              </ListItem>
            )} */}

            {/* Notifications */}
            {windowSize < 768 && (
              <ListItem
                className={styles.listItem}
                button
                type="smallHide"
                selected={selectedIndex === 5}
                component={Link}
                to="/u/notification"
                onClick={(event: any) => {
                  closePanel();
                  handleListItemClick(event, 5);
                }}
              >
                <ListItemIcon>
                  <span
                    className={`material-icons ${styles.iconMaterialDesign}`}
                  >
                    notifications
                  </span>
                </ListItemIcon>
                <ListItemText primary="Notifications" />
              </ListItem>
            )}

            {/* <ListItem
              button
              className={styles.listItem}
              selected={selectedIndex === 30}
              onClick={event => {
                handleClickCalculator();
                handleListItemClick(event, 30);
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  calculate
                </span>
              </ListItemIcon>
              <ListItemText primary="Calculator" />
              {!openCalculator ? (
                <span className="material-icons">expand_more</span>
              ) : (
                <span className="material-icons">expand_less</span>
              )}
            </ListItem> */}
            {/* <Collapse in={openCalculator} timeout="auto" unmountOnExit>
              <List component="div" disablePadding className={styles.subMenu}>
                <ListItem
                  className={styles.listItem}
                  component={Link}
                  to="/u/calculator/p-followers"
                  button
                  selected={selectedIndex === 31}
                  onClick={(event: any) => {
                    handleListItemClick(event, 31);
                    closePanel();
                  }}
                >
                  <ListItemIcon>
                    <span
                      style={{ width: '30px' }}
                      className={`material-icons ${styles.iconMaterialDesign}`}
                    >
                      calculate
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="Follower Goal Calculator" />
                </ListItem>
                {window.location.pathname !== 'quickcam.app' && (
                  <ListItem
                    className={styles.listItem}
                    button
                    selected={selectedIndex === 32}
                    component={Link}
                    to="/u/calculator/p-income-2"
                    onClick={(event: any) => {
                      closePanel();
                      handleListItemClick(event, 32);
                    }}
                  >
                    <ListItemIcon>
                      <span
                        style={{ width: '30px' }}
                        className={`material-icons ${styles.iconMaterialDesign}`}
                      >
                        calculate
                      </span>
                    </ListItemIcon>
                    <ListItemText primary="Income Goal Calculator" />
                  </ListItem>
                )}
              </List>
            </Collapse> */}

            {/* Subscription */}
            {/* <ListItem
              className={styles.listItem}
              button
              selected={selectedIndex === 6}
              component={Link}
              to="/u/subscription"
              onClick={() => {
                closePanel();
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  paid
                </span>
              </ListItemIcon>
              <ListItemText primary="Subscription" />
            </ListItem> */}

            {/* <ListItem
              className={styles.listItem}
              button
              selected={selectedIndex === 7}
              component={Link}
              to="/u/payout"
              onClick={(event: any) => {
                closePanel();
                handleListItemClick(event, 7);
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  payment
                </span>
              </ListItemIcon>
              <ListItemText primary="Payout" />
            </ListItem> */}

            {/* <ListItem
              className={styles.listItem}
              button
              selected={selectedIndex === 8}
              component={Link}
              to="/u/commissions"
              onClick={(event: any) => {
                closePanel();
                handleListItemClick(event, 8);
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  payment
                </span>
              </ListItemIcon>
              <ListItemText primary="Commissions" />
            </ListItem> */}

            <ListItem
              className={styles.listItem}
              button
              selected={selectedIndex === 9}
              component={Link}
              to="/u/settings"
              onClick={(event: any) => {
                closePanel();
                handleListItemClick(event, 9);
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  settings
                </span>
              </ListItemIcon>
              <ListItemText primary="Settings" />
            </ListItem>
            <ListItem
              className={styles.listItem}
              button
              selected={selectedIndex === 10}
              onClick={(event: React.MouseEvent<EventTarget, MouseEvent>) => {
                closePanel();
                performLogout(event);
              }}
            >
              <ListItemIcon>
                <span className={`material-icons ${styles.iconMaterialDesign}`}>
                  logout
                </span>
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </div>
        </div>
      </SlidingPanel>
      <section className={styles.footer}>
        <span>
          <p>
            <Link to="/about-us">About us</Link>
          </p>
          <p>|</p>
          <p>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </p>
          <p>|</p>
          <p>
            <Link to="/cookie-policy">Cookie Policy</Link>
          </p>
          <p>|</p>
          <p>
            <Link to="/terms-and-conditions">Terms of Service</Link>
          </p>
          <p>|</p>
          <p>
            <Link to="/trust-policy">Trust Policy</Link>
          </p>
          <p className={styles.hidden}>|</p>
        </span>
        <p>&copy; Copyright 2025 QuickCam, LLC. All rights reserved.</p>
      </section>
    </Grid>
  );
}

export default withRouter(Layout);
